import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-employees-orgchart',
  templateUrl: './employees-orgchart.component.html',
  styleUrls: ['./employees-orgchart.component.less']
})
export class EmployeesOrgchartComponent {
}
